import React, { useMemo } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import QueueConfiguration from "./component/queueConfiguration";
import GeneralQueue from "./component/generalQueue";
import { Card, Menu, MenuItem, Link } from "@mui/material";
import AgentSetting from "./component/agent";
import Campaign from "./component/campaign";
import DayTimeSetting from "./component/day&timeSetting";
import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
import { useMaterialUIController, setUpdateListFlag } from "context";
import { operationURLS, getColumns } from "./model";
import { useState, useEffect } from "react";
import CTLNotification from "application/components/CTLNotification";
import { application } from "globals/endpoints";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import AllReports from "./component/allCallcenterRepots";
import MoreIcon from "@mui/icons-material/More";
import CMSReport from "../Reports/cms_Reports";
import CallDisposition from "../Reports/callDisposition";
import CampaignSummary from "../Reports/campaignSummary";
import UserLoginLogout from "../Reports/UserLoginLogout";
import OperatorSummery from "../Reports/operatorSummaryReport";
import GroupAbandonedCall from "../Reports/AgentGroupAbandonedCall";
import AgentDailyPerformance from "../Reports/AgentDailyPerformance";
import AgentDailyReport from "../Reports/agentDailyReport";
import CallCenterConfigurationIVR from "./component/callCenterConfigurationIVR";
import AgentCallDataAnalysis from "../Reports/agentCallDataAnalysis";
import CallerCallDataAnalysis from "../Reports/callerCallDataAnalysis";
import LastAbandonedRecords from "../Reports/lastAbandonedRecords";
import QueueAbandonedReport from "../Reports/queueAbandonedReport";
import DispositionAnalysisQueue from "../Reports/dispositionAnalysisQueue";
import AnsweredReport from "../Reports/answeredReport";
import MDTypography from "components/MDTypography";
import { setCallcenterReportsName } from "context";
import QueueTimeInterval from "../Reports/queueTimeInterval";
import LeadSummary from "../Reports/LeadSummary";
import AgentPerformanceSummary from "../Reports/AgentPerformanceSummary";
import QueuePerformance from "../Reports/queuePerformance";
import QueuePerformanceSummary from "../Reports/QueuePerformanceSummaryReports";
import SkippedNumber from "../Reports/skippdNumber";
import CallBack from "../Reports/callBack";
import BlasterReports from "../Reports/blasterReport";
import FeedBackReport from "../Reports/feedBackReport";
import { setShowAgent } from "context";
import QueueReports from "../Reports/QueueReports";
import CallBackReports from "../Reports/callBack";
import CustomerAgentDailyPerformance from "../Reports/customerAgentPerformanceDaily";
import CustomerAgentPerformanceSummary from "../Reports/customerAgentPerformanceSummary";

function CallCenterConfigurations({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, queueValue, ivrExtension, callcenterReportsName } =
    controller;
  const [menuValue, setMenuValue] = useState();
  const [tabValue, setTabValue] = useState(0);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [updateList, setUpdateList] = useState(Date.now());
  const [additionalTabComponentState] = useState(null);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleOpenReport = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  function onOpenForm() {
    setFormData({
      eventTime: Date.now(),
    });
    setOpenForm(true);
  }

  function onCloseForm() {
    setOpenForm(false);
    setShowAgent(dispatch, false);
  }

  function CreateQueue(data) {
    application
      .post(operationURLS.queueCreate, data)
      .then((response) => {
        setUpdateList(Date.now());
        setUpdateListFlag(dispatch, true);
        setOpenForm(false);
        setNotify({
          isOpen: true,
          status: response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status: error.response.data.messageDetail,
          type: "error",
          pagename: pageName,
          message: error.response.data.message,
        });
      });
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    setCallcenterReportsName(dispatch, "");

    setMenuValue("");
  };

  const groupMenu = AuthenticationService.getGroupMenus();
  let StaticTabs =
    AuthenticationService.allowAdminMenus() ||
    AuthenticationService.allowManagerMenus();
  let isTeamLeader = AuthenticationService.allowCallcenterTabMenus();
  let tabName = [];

  if (StaticTabs) {
    tabName = [
      "GENERAL-SETTING",
      "ADVANCE-SETTING",
      "AGENT-SETTING",
      "CAMPAIGNS-SETTING",
      "DAY&TIME-SETTING",
      "IVR-FLOW",
      "REPORT",
    ];
  } else if (
    isTeamLeader === true ||
    isTeamLeader === undefined ||
    isTeamLeader === ""
  ) {
    tabName = ["AGENT-SETTING", "CAMPAIGNS-SETTING", "REPORT"];
  }
  const dynamicTabNames = tabName?.filter((menu) =>
    groupMenu.find(
      (DynamicTab) =>
        DynamicTab.name === "Call Center Tab" &&
        DynamicTab.menus.some((item) => item && item.menuName === menu)
    )
  );
  const tabComponents = useMemo(() => (
    StaticTabs
      ? tabName
      : isTeamLeader === true ||
        isTeamLeader === undefined ||
        isTeamLeader === ""
      ? tabName
      : dynamicTabNames
  ).map((tabName, index) => {
    switch (tabName) {
      case "GENERAL-SETTING":
        return (
          <GeneralQueue
            key={index}
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "ADVANCE-SETTING":
        return (
          <QueueConfiguration
            key={index}
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "AGENT-SETTING":
        return (
          <AgentSetting
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "CAMPAIGNS-SETTING":
        return (
          <Campaign
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "DAY&TIME-SETTING":
        return (
          <DayTimeSetting
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "IVR-FLOW":
        return (
          <CallCenterConfigurationIVR
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "REPORT":
        return (
          <AllReports
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      default:
        return null;
    }
  }), [StaticTabs, isTeamLeader, tabName, dynamicTabNames, onLoad, registerCallBacks, pageId, searchText, pageName]);

  const handleMenuChange = (newValue) => {
    setMenuValue(newValue);
    setCallcenterReportsName(dispatch, newValue.name);
    handleClose();
  };

  // compute additional tab component lazily to avoid state updates on render
  const additionalTabComponent = useMemo(() => {
    switch (menuValue?.key) {
      case "csm_reports":
        return (
          <CMSReport
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "callDisposition.Analysis.Campaign":
        return (
          <CallDisposition
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "campaign.Summary":
        return (
          <CampaignSummary
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
            pageName={pageName}
          />
        );
      case "user.login.logout":
        return (
          <UserLoginLogout
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "queue.Time.Interval":
        return (
          <QueueTimeInterval
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "Operator.Summary":
        return (
          <OperatorSummery
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "agent.performance.Daily":
        return (
          <AgentDailyPerformance
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "agent.performance.summary":
        return (
          <AgentPerformanceSummary
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "queue.Performance.Daily":
        return (
          <QueuePerformance
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "queue.Performance.Summary":
        return (
          <QueuePerformanceSummary
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "lead.Summary":
        return (
          <LeadSummary
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "group.abandoned.call":
        return (
          <GroupAbandonedCall
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "agent.Call.DataAnalysis":
        return (
          <AgentCallDataAnalysis
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "caller.Call.DataAnalysis":
        return (
          <CallerCallDataAnalysis
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "last.Abandoned.Records":
        return (
          <LastAbandonedRecords
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "answered":
        return (
          <AnsweredReport
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "dispositionAnalysisQueue":
        return (
          <DispositionAnalysisQueue
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "unAnswered":
        return (
          <QueueAbandonedReport
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "agent-DailyReport":
        return (
          <AgentDailyReport
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "skipped.Number":
        return (
          <SkippedNumber
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "call.Back":
        return (
          <CallBackReports
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "blaster":
        return (
          <BlasterReports
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "feedBack":
        return (
          <FeedBackReport
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
      case "disposition.Analysis.Queue":
        return (
          <QueueReports
            onLoad={onLoad}
            registerCallBacks={registerCallBacks}
            pageId={pageId}
            searchText={searchText}
          />
        );
        case "customer.agent.performance.Daily":
          return (
            <CustomerAgentDailyPerformance
              onLoad={onLoad}
              registerCallBacks={registerCallBacks}
              pageId={pageId}
              searchText={searchText}
            />
          );
          case "customer.agent.performance.summary":
            return (
              <CustomerAgentPerformanceSummary
                onLoad={onLoad}
                registerCallBacks={registerCallBacks}
                pageId={pageId}
                searchText={searchText}
              />
            );
      default:
        return null;
    }
  }, [menuValue, onLoad, registerCallBacks, pageId, searchText, pageName]);
  // Call Center Dynamic Menu Get From Login Response 
  const callCenterConfigurationReports = useMemo(() => {
    try {
      const groupMenus = AuthenticationService.getGroupMenus();
      if (!Array.isArray(groupMenus)) return [];
      return groupMenus
        .map((item) => item?.callCenterReport)
        .filter((reports) => Array.isArray(reports))
        .flat()
        .filter((menu) => menu && typeof menu === "object")
        .map((menu) => ({
          icon: menu?.icon ?? null,
          key: menu?.key ?? null,
          name: menu?.menuName ?? "",
          url: menu?.url ?? "",
          productionReady: menu?.productionReady ?? false,
          description: menu?.description ?? "",
        }));
    } catch (err) {
      console.error(
        "Error generating dynamic callCenterConfigurationReports:",
        err
      );
      return [];
    }
  }, []);
  return (
    <>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#49a3f1",
          },
          marginBottom: 2,
          height: 50,
        }}
      >
        {(StaticTabs
          ? tabName
          : isTeamLeader === true ||
            isTeamLeader === undefined ||
            isTeamLeader === ""
          ? tabName
          : dynamicTabNames
        ).map((name, index) => (
          <Tab
            key={index}
            label={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{name}</span>
                {index ===
                  (StaticTabs
                    ? tabName
                    : isTeamLeader === true ||
                      isTeamLeader === undefined ||
                      isTeamLeader === ""
                    ? tabName
                    : dynamicTabNames
                  ).length -
                    1 && (
                  <div
                    style={{
                      marginLeft: "28px",
                      alignItems: "center",
                    }}
                  >
                    <MoreIcon
                      style={{ cursor: "pointer" }}
                      onClick={handleOpenReport}
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    />
                  </div>
                )}
              </div>
            }
          />
        ))}
      </Tabs>
      <Card>{additionalTabComponent || tabComponents[tabValue]}</Card>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {React.Children.toArray(
          callCenterConfigurationReports.map((menuItem) => {
            if (!menuItem) return null;
            return (
              <MenuItem
                sx={{ p: 1 }}
                key={menuItem.key ?? menuItem.name}
                onClick={() => handleMenuChange(menuItem)}
              >
                <Link component="button">{menuItem.name}</Link>
              </MenuItem>
            );
          })
        )}
      </Menu>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default CallCenterConfigurations;
